import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent} from '@angular/common/http';
import {Store} from '@ngxs/store';
import {FileService} from './file.service';

@Injectable()
export class AttachmentService {

    constructor(
        private http: HttpClient,
        private store: Store,
        private fileService: FileService
    ) {
    }

    addAttachment(callback: (event: HttpEvent<{}>) => void) {
        const input: HTMLInputElement = document.createElement('input');
        input.type = 'file';
        input.style.cssText = 'display: none';
        input.oninput = () => {
            if (input.files.length !== 1) {
                return undefined;
            }
            return this.fileService.postFile(input.files[0])
                .subscribe((event) => {
                    callback(event);
                    input.remove();
                });
        };
        document.body.appendChild(input);
        input.click();
    }
}
